// extracted by mini-css-extract-plugin
export var orderDetails = "_ug-2";
export var orderImage = "_ug-1";
export var orderMeta = "_ug-3";
export var orderSummary = "_ug-0";
export var rightArrow = "_ug-4";